<template>
  <teleport to="body">
    <div
      v-if="modelValue"
      class="modal-overlay"
      role="dialog"
      aria-modal="true"
      @click.self="close"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">View Permission</h5>
          <button type="button" class="close" aria-label="Close" @click="close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="mb-2"><strong>Visibility</strong></div>
          <div class="text-muted small mb-2" v-if="loading">Loading current settings…</div>

          <div class="custom-control custom-radio mb-2">
            <input
              type="radio"
              id="permPublic"
              class="custom-control-input"
              value="public"
              v-model="viewPermission"
              :disabled="loading || saving"
            />
            <label class="custom-control-label" for="permPublic">Public</label>
            <p>All Photos Will Be Accessable For viewing & Download by Everyone On the Guest List</p>
          </div>

          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="permRestricted"
              class="custom-control-input"
              value="private"
              v-model="viewPermission"
              :disabled="loading || saving"
            />
            <label class="custom-control-label" for="permRestricted">Restricted</label>
            <p>Only Photos That Match With Uploaded Selfies & Common Photos Will be Available for Viewing</p>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" :disabled="saving" @click="close">Cancel</button>
          <button class="btn btn-primary" :disabled="saving" @click="save">
            <span v-if="!saving">Save</span>
            <span v-else><span class="spinner-border spinner-border-sm mr-1"></span>Saving…</span>
          </button>
        </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
/* eslint-env vue/setup-compiler-macros */
import { ref, watch, onMounted } from 'vue'
import api from '@/services/api'

const props = defineProps({
  modelValue: { type: Boolean, default: false }, // v-model
  eventId:     { type: [String, Number], required: true },
  sessionUserId: { type: [String, Number], required: true }
})
const emit = defineEmits(['update:modelValue', 'saved'])

const viewPermission = ref('public')
const loading = ref(false)
const saving = ref(false)

function close(){ emit('update:modelValue', false) }

async function load() {
  try {
    loading.value = true
    const fd = new FormData()
    fd.append('user_id', String(props.sessionUserId))
    fd.append('event_id', String(props.eventId))
    const res = await api.updatePermissions(fd)
    const payload = res?.data ?? res
    const cfg = payload?.data || {}
    const modeV = String(cfg.type_event || cfg.photo_booth_type || 'public').toLowerCase()
    viewPermission.value = (modeV === 'private' || modeV === 'restricted') ? 'private' : 'public'
  } catch (e) {
    console.error('getAlbumSetting error:', e)
    viewPermission.value = 'public'
  } finally {
    loading.value = false
  }
}

async function save(){
  try {
    saving.value = true
    const fd = new FormData()
    fd.append('eventid', String(props.eventId))
    fd.append('photo_booth_type', viewPermission.value === 'private' ? 'private' : 'public')
    const upd = await api.updatePermissions(fd)
    const ok = upd?.status === true || upd?.data?.status === true || upd?.data?.status === 'ok'
    if (!ok) throw new Error('Failed to update visibility')
    emit('saved', viewPermission.value)
    close()
  } catch (e) {
    console.error('updatePermissions error:', e)
    alert('Could not save view permissions.')
  } finally {
    saving.value = false
  }
}

watch(()=>props.modelValue,(open)=>{ if(open) load() })
onMounted(()=>{ if (props.modelValue) load() })
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  z-index: 1050;
  overflow-y: auto;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 520px;
}

.modal-content {
  border: none;
  border-radius: 18px;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.25);
}

.modal-header {
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}

.modal-footer {
  border-top: 1px solid rgba(15, 23, 42, 0.08);
}

@media (max-width: 576px) {
  .modal-overlay {
    padding: 1rem;
  }
  .modal-content {
    border-radius: 14px;
  }
}
</style>
